<template>
	<div>
		<div style="background-color: #fff;padding: 2%;text-align: left;">
			<el-form :model="form" :inline="true">
				<el-form-item label="物品名称">
					<el-input v-model="form.goodsName" placeholder="请输入需要查询的物品名称或品牌" maxlength="10" style="width: 15vw;"
						clearable prefix-icon="el-icon-search"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="query(form.goodsName)" type="primary" icon="el-icon-search"
						style="left: 10%;position: relative;">搜索</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div style="padding: 1% 1%;background-color: #fff;margin-top:1vh;min-height:70vh;cursor: pointer;">
			<div v-if="showData">
				<el-table :data="restrictionsList" height="700"
					:header-cell-style="{ background: '#409EFF', color: '#FFFFFF' }"
					:cell-style="{ color: '#303133' ,'font-family': 'initial'}" border>
					<el-table-column prop="goodsName" width="150" label="物品名称">
						<template  #default="scope">
							<span style="font-size: small;">
								{{scope.row.goodsName}}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="goodsType" label="物品类型"></el-table-column>
					<el-table-column prop="restrictionsType" label="寄递限制">
						<template  #default="scope">
							<el-tag
								:type="scope.row.restrictionsType == '禁止寄递' ? 'danger' : scope.row.restrictionsType == '限制寄递' ? 'warning': 'success'"
								disable-transitions>
								{{scope.row.restrictionsType}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="restrictionsExplanation" width="600" label="限制说明">
						<template  #default="scope">
							<!-- 							<span v-if="scope.row.restrictionsExplanation=='【此物品法律法规禁止寄递！】'" style="color: #F56C6C;">{{scope.row.restrictionsExplanation}}</span> -->
							<span
								:style="{color: scope.row.restrictionsExplanation=='【此物品法律法规禁止寄递！】' ? '#F56C6C' : scope.row.restrictionsType == '限制寄递' ? '#303133': '#303133'}">{{scope.row.restrictionsExplanation}}</span>
							<!-- <span v-else>{{scope.row.restrictionsExplanation}}</span> -->
						</template>
					</el-table-column>
					<el-table-column prop="suggestInsurance" label="建议保价"></el-table-column>
				</el-table>
			</div>
			<el-empty v-if="!showData" description="空空如也"></el-empty>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					goodsName: ''
				},
				showData: false,
				restrictionsList: []
			}
		},
		methods: {
			query(goodsName) {
				this.showData = false;
				const loading = this.$loading({
					lock: true,
					text: '加载中',
					spinner: 'el-icon-loading',
					background: 'rgba(107, 107, 107, 0.7)'
				});
				this.apiService.post({
						modules: "goodsRestrictions",
						content: {
							goodsName: goodsName
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.restrictionsList = res.data.restrictionsList;
							this.showData = true;
						}
					})
					.finally(() => {
						loading.close();
					})
			}

		},
		created() {

		}
	}
</script>

<style scoped>
	/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
	.trail_show_window::-webkit-scrollbar {
		width: 7px;
		height: 7px;
		background-color: #fcfcfc;
	}

	/*定义滚动条轨道 内阴影+圆角*/
	.trail_show_window::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(244, 244, 244, 0.3);
		-webkit-box-shadow: inset 0 0 6px rgba(240, 240, 240, 0.3);
		border-radius: 10px;
		background-color: #f5f5f5;
	}

	/*定义滑块 内阴影+圆角*/
	.trail_show_window::-webkit-scrollbar-thumb {
		border-radius: 10px;
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
		background-color: #dadada;
	}
</style>